import styled from "styled-components";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import IconWrapper from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";

export const Wrapper = styled.details`
    background: ${theme.colors.white};
    border: 1px solid ${theme.colors.platinumMedium};
    border-radius: 4px;
`;

export const Header = styled.summary`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${theme.space[2]}px;

    /* Hide default markup */
    &::marker,
    &::-webkit-details-marker {
        display: none;
        width: 0;
        height: 0;
        content: "";
    }

    @media ${getBreakpoint("up", "xl")} {
        padding: ${theme.space[3]}px;
    }
`;

export const HeaderContent = styled.div`
    display: flex;
    align-items: center;
    column-gap: ${theme.space[1]}px;

    ${IconWrapper} {
        display: flex;
        align-items: center;
    }
`;

export const HeaderTitle = styled.h3`
    margin: 0;
    font-family: ${theme.fonts.regular};
    font-size: 1.4rem;
    letter-spacing: 0.2rem;
    line-height: 2.2rem;
    text-transform: uppercase;
    color: ${theme.colors.midnight};

    @media ${getBreakpoint("up", "xl")} {
        font-size: 1.6rem;
    }
`;

export const HeaderDescription = styled.div`
    font-family: ${theme.fonts.book};
    font-size: 1.6rem;
    letter-spacing: 0.1rem;
    line-height: 2rem;
    color: ${theme.colors.brushedSteel};
`;

export const ButtonText = styled.span`
    display: none;
    /* Fix alignment text in button */
    position: relative;
    top: 2px;
    @media ${getBreakpoint("up", "xl")} {
        display: inline-block;
    }
`;

export const Button = styled.button<{ isActive?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${theme.space[1]}px;
    width: 32px;
    height: 32px;
    padding: ${theme.space[1] / 2}px;
    font-family: ${theme.fonts.bold};
    font-size: 1.4rem;
    letter-spacing: 0.1rem;
    line-height: 1.4rem;
    text-transform: uppercase;
    color: ${({ isActive }) => (isActive ? theme.colors.azure : theme.colors.white)};
    background-color: ${({ isActive }) => (isActive ? theme.colors.white : theme.colors.azure)};
    border: 1px solid ${({ isActive }) => (isActive ? theme.colors.platinumMedium : theme.colors.azure)};
    border-radius: 0.4rem;

    &:is(:hover, :active) {
        color: ${({ isActive }) => (isActive ? theme.colors.azure : theme.colors.white)};
        background-color: ${({ isActive }) => (isActive ? theme.colors.platinumMedium : theme.colors.azureHover)};
    }

    ${IconWrapper} {
        display: flex;
        align-items: center;
    }

    @media ${getBreakpoint("up", "xl")} {
        width: auto;
        height: auto;
        padding: ${theme.space[3] / 2}px ${theme.space[2]}px;

        ${IconWrapper} {
            display: none;
        }
    }
`;

export const Content = styled.div`
    border-top: 1px solid ${theme.colors.platinumMedium};
`;
